module.exports = __webpack_public_path__ + "img/app-logo-white.8582b747.png";